export default __webpack_public_path__ + "static/media/logo.0544c41e.svg";